<template>
  <h1>{{ $t('menu.pim.subpages.productsImage.header')}} ({{ this.hotSettings.data.length }})</h1>
  <div class="pb-4">
    <button class="appButton mt-2" @click="this.$router.push('/pim')">{{ $t('menu.pim.subpages.productsPricing.back')
      }}</button>
    <button class="appButton mt-2" @click="refresh()">{{ $t('menu.pim.subpages.productsPricing.refresh')
      }}</button>
  </div>
  <div
    class="mb-4 rounded-md"
    :style="missingImageRows.length === 0
      ? 'background: #142218; border: 1px solid rgba(74,222,128,0.3);'
      : 'background: #2a2410; border: 1px solid rgba(250,204,21,0.3);'"
  >
    <div
      class="p-3 flex items-center cursor-pointer select-none"
      @click="missingImageExpanded = !missingImageExpanded"
    >
      <span class="mr-2">{{ missingImageExpanded ? '▼' : '▶' }}</span>
      <span>{{ $t('menu.pim.subpages.productsImage.missingImage') }}:</span>
      <span class="ml-2 font-semibold" :class="missingImageRows.length === 0 ? 'text-green-400' : 'text-yellow-400'">
        {{ missingImageRows.length }}
      </span>
    </div>
    <div v-if="missingImageExpanded && missingImageRows.length > 0" class="px-3 pb-3">
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left" style="border-bottom: 1px solid rgba(255,255,255,0.1);">
            <th class="py-2 pr-4">SKU</th>
            <th class="py-2 pr-4">Title</th>
            <th class="py-2 pr-4">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in missingImageRows" :key="row[0]" style="border-bottom: 1px solid rgba(255,255,255,0.05);">
            <td class="py-1 pr-4">{{ row[1] }}</td>
            <td class="py-1 pr-4">{{ row[2] }}</td>
            <td class="py-1 pr-4">{{ row[3] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="flex">
    <div class="w-full">
      <hot-table :settings="hotSettings"></hot-table>
    </div>
  </div>

</template>

<script>
import { useSettings } from '@/store/user'
import mixins from '@/components/mixins';
import { HotTable } from '@handsontable/vue3';
import { registerAllModules } from 'handsontable/registry';
import 'handsontable/dist/handsontable.full.css';

// register Handsontable's modules
registerAllModules();

export default {
    mixins: [mixins],
    setup() {
        const user = useSettings();

        return { user }
    },
    created() {
      this.hotSettings.data = this.user.pim.products.map(product => {
        return [product.id, product.sku, product.title, product.status, product.images];
      });
    },
    components: {
      HotTable,
    },
    computed: {
      missingImageRows() {
        return this.hotSettings.data.filter(row => {
          const status = (row[3] || '').toString().toUpperCase();
          if (status !== 'ACTIVE') return false;
          const images = row[4];
          if (images === null || images === undefined) return true;
          if (Array.isArray(images)) return images.length === 0;
          if (typeof images === 'number') return images === 0;
          const str = images.toString().trim();
          return str === '' || str === '0' || str === '[]';
        });
      }
    },
    data() {
      return {
        missingImageExpanded: false,
        hotSettings: {
          data: [],
          height: 'auto',
          filters: true,
          dropdownMenu: true,
          manualRowMove: false,
          autoWrapRow: true,
          autoWrapCol: true,
          fillHandle: true,
          rowHeaders: true,
          colHeaders: ['ID', 'SKU', 'Title', 'Status', 'Images'],
          columns: [
            { data: 0, name: 'id', type: 'numeric', editor: false},
            { data: 1, name: 'sku', type: 'text', editor: false},
            { data: 2, name: 'title', type: 'text', editor: false},
            { data: 3, name: 'status', type: 'text', editor: false},
            { data: 4, name: 'images', type: 'text', editor: false},
          ],
          // licenseKey: '53013-4578b-9e935-c450e-92257',
          licenseKey: 'non-commercial-and-evaluation',
          afterChange: (changes) => {
            changes?.forEach(([row, prop, oldValue, newValue]) => {
              
              // extract the Shopify ID from the product ID
              const match = this.user.pim.products[row].id.match(/gid:\/\/shopify\/Product\/(\d+)/);
              const Shopify_id = match ? match[1] : null;

              const field = this.hotSettings.columns[prop].name;
              const field_type = this.hotSettings.columns[prop].field_type || 'single_line_text_field';
              const namespace = this.hotSettings.columns[prop].namespace || 'custom';

              const obj = {
                productId: Shopify_id,
                metafield: field,
                value: newValue,
                type: field_type,
                namespace: namespace
              };

              console.log('Updating product pricing:', obj);
              
              this.user.updateProductPim(obj);
            });
          }
        },
      };
    },
    methods: {
       refresh() {
        this.hotSettings.data = [];
        this.user.getProductsPim().then(() => {
          this.hotSettings.data = this.user.pim.products.map(product => {
            return [product.id, product.sku, product.title, product.status, product.images];
          });
        });
      }
    }
};

</script>